import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Observable } from 'rxjs';
import { FileOpener } from '@ionic-native/file-opener/ngx';


@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {

  private locale: string = 'pt';

  constructor(
    private http: HttpClient,
    private fileOpener: FileOpener,
  ) {
  }

  download(id : number): Promise<any> {
    return new Promise(resolve => {
      this.http.get(`${this.locale}/attachments/${id}/download`, {
        responseType: 'blob',
        reportProgress: true,
        observe: 'events',
      })
        .subscribe(
          async(event) => {
            if (event.type == HttpEventType.Response) {
              resolve(event.body);
            }
          }
        );
    });
  }


  async openBlob(blob: Blob): Promise<void> {
    return new Promise(async resolve => {
      const name = 'report.pdf';
      const mimeType = 'application/pdf';
      const base64 = await this.convertBlobToBase64(blob) as string;

      const storedFile = await Filesystem.writeFile({
        path: name, // report.pdf
        data: base64,
        directory: Directory.Documents,
      });
      const path = storedFile.uri;

      this.fileOpener.open(path, mimeType)
        .then(() => {
          console.log('File is opened');
          resolve();
        })
        .catch(error => {
          console.log('Error while opening file: ', error);
          resolve();
        });
    });
  }

  private convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader;
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };

    reader.readAsDataURL(blob);
  });

  private handleError(error: Response) {
    console.error(JSON.stringify(error));
    console.error(error);
    return Observable.throw(error.statusText);
  }
}
